export default "__VITE_ASSET__DGK7sxt5__"